import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { ButtonLink } from "../../../components/ui/button";
import { SectionHeader } from "../../../components/ui/section";
import type { ContractorSitePageProps } from "../types";

type CTABannerSectionProps = Pick<ContractorSitePageProps, "business"> & {
  quoteFormEnabled?: boolean;
};

export const CTABannerSection: React.FC<CTABannerSectionProps> = ({
  business,
  quoteFormEnabled = true,
}) => (
  <section className="relative overflow-hidden border-y border-border bg-muted/40 py-16 sm:py-20">
    <div className="absolute left-0 top-0 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent/10" />
    <div className="absolute bottom-0 right-0 h-96 w-96 translate-x-1/3 translate-y-1/3 rounded-full bg-primary/10" />

    <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
      <SectionHeader
        center
        kicker="Next Step"
        kickerTone="accent"
        title="Ready to start your next project?"
        description={
          quoteFormEnabled
            ? "Contact us for a no-obligation estimate and a clear scope for your project."
            : "Reach out by phone or email — we are happy to answer questions about your project."
        }
      />
      <div className="mt-3 flex flex-col items-center justify-center gap-4 sm:flex-row">
        <ButtonLink href="#contact" variant="default" size="lg">
          {quoteFormEnabled ? "Get Your Free Quote" : "Contact Us"}
          <ArrowRight className="h-5 w-5" />
        </ButtonLink>
        <ButtonLink
          href={`tel:${business.phone}`}
          variant="outline"
          size="lg"
          className="border-primary/35 text-primary hover:border-primary/50 hover:bg-primary/5"
        >
          <Phone className="h-5 w-5 shrink-0" />
          Call {business.phone}
        </ButtonLink>
      </div>
    </div>
  </section>
);
